import { scroller } from 'react-scroll'
import { ArrowCta } from '@mc/certificates-design-system'
import { useTranslation } from '@mc/i18n'
import { LogoSection } from 'pages/certificates/components/common/LogoSection'
import { HubHeroSubsNote } from 'pages/certificates/experiments/mccerts-2624_v1_hub_subs_row'
import { TrackClick, TrackingAttributes } from 'pages/certificates/tracking'
import { HeroVideo } from './HeroVideo'

export const TITLE_ID = 'masterclassCertificates.title'

export const HeroSection = () => {
  const { t } = useTranslation('@mc/certificates')

  return (
    <TrackingAttributes location='hero'>
      <section aria-labelledby={TITLE_ID}>
        <div className='container flex flex-col lg:flex-row items-center justify-between pt-6 pb-8 gap-8'>
          <div className='flex flex-col items-center lg:items-start gap-6 flex-[5]'>
            <LogoSection />
            <div className='text-center lg:text-left'>
              <h1 className='text-c-beige-1300 lg:max-w-[17ch] c-d-1 mb-5'>
                {t('marketingPages.hub.hero.title')}
              </h1>

              <p className='text-c-text-tint-3 c-body-xlarge'>
                {t('marketingPages.hub.hero.description')}
              </p>
            </div>

            <TrackClick event='certificateLandingClick'>
              <ArrowCta
                onClick={() =>
                  scroller.scrollTo('browse-certificates', { duration: 250 })
                }
              >
                {t('marketingPages.hub.hero.cta')}
              </ArrowCta>
            </TrackClick>
            <HubHeroSubsNote />
          </div>

          <HeroVideo
            mediaUuid='a528cb48-dd8a-4981-938e-bb58edc95a4f'
            fallbackImageUrl='https://static.masterclass.com/certs-hero-fallback-1x1.jpg'
            fullWidth
          />
        </div>
      </section>
    </TrackingAttributes>
  )
}
